import { Button, Col, Row, Tooltip } from 'antd';
import CustomInput from '../../../../../components/CustomInput';
import { Edit } from '../../../../../components/Svg/Svg';
import { useState } from 'react';
import { useMemo } from 'react';
import { QuestionCircleOutlined } from '@ant-design/icons';

export default function ClientSftpForm({
    data,
    onChange,
    clientId,
    errors,
    setIsDisabledFields,
    isDisabledFields,
}) {
    const [arrow] = useState('Show');

    const mergedArrow = useMemo(() => {
        if (arrow === 'Hide') {
            return false;
        }

        if (arrow === 'Show') {
            return true;
        }

        return {
            pointAtCenter: true,
        };
    }, [arrow]);

    const tootipText = (
        <ul>
            <li>• root directory = /to_defentry</li>
            <li>• account creation = /activation sub-folder</li>
            <li>• account removal = /deactivation sub-folder</li>
        </ul>
    );

    return (
        <div className="details-table">
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Name
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                id={`sftp-name-${clientId}`}
                                name="name"
                                placeholder="Enter name"
                                onInputChange={(e) => onChange(e)}
                                inputValue={data?.name}
                                width="100%"
                                errorText={errors?.name}
                                className="input-dark"
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Base URL
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                id={`sftp-base_url-${clientId}`}
                                name="base_url"
                                placeholder="Enter base url"
                                onInputChange={(e) => onChange(e)}
                                className="input-dark"
                                width="100%"
                                inputValue={data?.base_url}
                                errorText={errors?.base_url}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Login
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                id={`sftp-login-${clientId}`}
                                name="login"
                                placeholder="Enter login"
                                onInputChange={(e) => onChange(e)}
                                className="input-dark"
                                width="100%"
                                inputValue={data?.login}
                                errorText={errors?.login}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Password
                        </div>
                    </Col>
                    <Col span={17}>
                        <form>
                            <div className="details-table__cell details-table__cell--editable">
                                <CustomInput
                                    id={`sftp-password-${clientId}`}
                                    name="password"
                                    placeholder="Enter password"
                                    onInputChange={(e) => onChange(e)}
                                    className="input-dark"
                                    inputValue={data?.password}
                                    width="100%"
                                    errorText={errors?.password}
                                />
                            </div>
                        </form>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            B2C URL
                        </div>
                    </Col>
                    <Col span={17}>
                        <div
                            className="details-table__cell details-table__cell--editable"
                            style={{ display: 'flex' }}
                        >
                            <CustomInput
                                id={`sftp-b2c_url-${clientId}`}
                                name="create_account_b2c_url"
                                placeholder="Enter b2c URL"
                                onInputChange={(e) => onChange(e)}
                                className="input-dark"
                                inputValue={data?.create_account_b2c_url}
                                width="100%"
                                disabled={isDisabledFields.b2cUrl}
                            />
                            <Button
                                type="primary"
                                size="large"
                                onClick={() =>
                                    setIsDisabledFields({
                                        ...isDisabledFields,
                                        b2cUrl: !isDisabledFields.b2cUrl,
                                    })
                                }
                                style={{ marginLeft: '16px' }}
                            >
                                <Edit />
                                <span style={{ marginLeft: '8px' }}>Edit</span>
                            </Button>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            B2B URL
                        </div>
                    </Col>
                    <Col span={17}>
                        <div
                            className="details-table__cell details-table__cell--editable"
                            style={{ display: 'flex' }}
                        >
                            <CustomInput
                                id={`sftp-b2b_url-${clientId}`}
                                name="create_account_b2b_url"
                                placeholder="Enter b2b URL"
                                onInputChange={(e) => onChange(e)}
                                className="input-dark"
                                width="100%"
                                inputValue={data?.create_account_b2b_url}
                                disabled={isDisabledFields.b2bUrl}
                            />
                            <Button
                                type="primary"
                                size="large"
                                onClick={() =>
                                    setIsDisabledFields({
                                        ...isDisabledFields,
                                        b2bUrl: !isDisabledFields.b2bUrl,
                                    })
                                }
                                style={{ marginLeft: '16px' }}
                            >
                                <Edit />
                                <span style={{ marginLeft: '8px' }}>Edit</span>
                            </Button>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Mail sender address
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                id={`sftp-mail_from_address-${clientId}`}
                                name="mail_from_address"
                                placeholder="Enter mail sender address"
                                onInputChange={(e) => onChange(e)}
                                className="input-dark"
                                width="100%"
                                inputValue={data?.mail_from_address}
                                errorText={errors?.mail_from_address}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Mail sender name
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                id={`sftp-mail_from_name-${clientId}`}
                                name="mail_from_name"
                                placeholder="Enter mail sender name"
                                onInputChange={(e) => onChange(e)}
                                className="input-dark"
                                width="100%"
                                inputValue={data?.mail_from_name}
                                errorText={errors?.mail_from_name}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Mail recipient
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                id={`sftp-mail_recipient-${clientId}`}
                                name="mail_recipient"
                                placeholder="Enter mail recipient"
                                onInputChange={(e) => onChange(e)}
                                className="input-dark"
                                width="100%"
                                inputValue={data?.mail_recipient}
                                errorText={errors?.mail_recipient}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            SFTP host
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                id={`sftp-sftp_host-${clientId}`}
                                name="sftp_host"
                                placeholder="Enter SFTP host"
                                onInputChange={(e) => onChange(e)}
                                className="input-dark"
                                width="100%"
                                inputValue={data?.sftp_host}
                                errorText={errors?.sftp_host}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            SFTP port
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                id={`sftp-sftp_port-${clientId}`}
                                name="sftp_port"
                                placeholder="Enter SFTP port"
                                onInputChange={(e) => onChange(e)}
                                className="input-dark"
                                width="100%"
                                inputValue={data?.sftp_port}
                                errorText={errors?.sftp_port}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            SFTP username
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                id={`sftp-sftp_username-${clientId}`}
                                name="sftp_username"
                                placeholder="Enter SFTP username"
                                onInputChange={(e) => onChange(e)}
                                className="input-dark"
                                width="100%"
                                inputValue={data?.sftp_username}
                                errorText={errors?.sftp_username}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            SFTP password
                        </div>
                    </Col>
                    <Col span={17}>
                        <form>
                            <div className="details-table__cell details-table__cell--editable">
                                <CustomInput
                                    id={`sftp-sftp_password-${clientId}`}
                                    name="sftp_password"
                                    placeholder="Enter SFTP password"
                                    onInputChange={(e) => onChange(e)}
                                    className="input-dark"
                                    width="100%"
                                    inputValue={data?.sftp_password}
                                    errorText={errors?.sftp_password}
                                />
                            </div>
                        </form>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            SFTP directory{' '}
                            <Tooltip
                                placement="top"
                                title={tootipText}
                                arrow={mergedArrow}
                                overlayClassName="ant-tooltip-custom"
                            >
                                <QuestionCircleOutlined />
                            </Tooltip>
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                id={`sftp-sftp_directory-${clientId}`}
                                name="sftp_directory"
                                placeholder="Enter SFTP directory"
                                onInputChange={(e) => onChange(e)}
                                className="input-dark"
                                width="100%"
                                inputValue={data?.sftp_directory}
                                errorText={errors?.sftp_directory}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    );
}
